import LandingPageWeb from './LandingPageWeb';
export default LandingPageWeb;
